"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@eres/core");
var utils_1 = require("./utils");
function getBCSRating(request) {
    return utils_1.getUtils().httpUtils.httpPost(utils_1.getUtils().config.baseUrl() + "rating/get", request)
        .then(function (resp) {
        return checkValidationError(resp).then(function (x) {
            if (x) {
                x.propertyId = request.propertyId ? request.propertyId + "" : "";
                x.requestType = request.requestType ? request.requestType + "" : "";
            }
            return x;
        });
    });
}
exports.getBCSRating = getBCSRating;
function getBCSCertDetailUrl(buildingId) {
    return utils_1.getUtils().config.baseUrl() + ("rating/rating-score-report/building/" + buildingId);
}
exports.getBCSCertDetailUrl = getBCSCertDetailUrl;
function getBCSCertificate(buildingId) {
    return utils_1.getUtils().httpUtils.httpGet(utils_1.getUtils().config.baseUrl() + ("rating/certificates/building/" + buildingId))
        .then(checkValidationError);
}
exports.getBCSCertificate = getBCSCertificate;
function checkValidationError(response) {
    if (response) {
        if (response.validationErrorsList) {
            var errors = response.validationErrorsList;
            if (errors != undefined && Array.isArray(errors) && errors.length > 0) {
                var message = errors.map(function (e) { return e.errorMessageSet ? core_1.LocaleUtil.getLocalValue(e.errorMessageSet) : e.errorMessage; }).join("\n").trim();
                var errorNumbers = errors.filter(function (e) { return e.errorNumber === 410010; });
                return Promise.reject({
                    type: "ValidationError",
                    response: response && response.response ? response.response : undefined,
                    errors: errors,
                    message: message,
                    errorNumbers: errorNumbers,
                });
            }
        }
    }
    if (response.response && response.response.response)
        return Promise.resolve(response.response.response);
    return Promise.reject(response);
}
